import { IPaging, IQueryParameters, ISelectModel } from 'common/models';
import { removeFirstEmptyBracket as transformParams } from 'helper/strings';
import API from 'services/api';

interface IProps extends IPaging, IQueryParameters {}

export const getCalculationServices = ({ params }: IProps): Promise<ISelectModel<number>[]> => {
  return API.get('/api/root/services/accommodation', {
    params: { ...params },
    paramsSerializer: parameters => transformParams(parameters),
  }).then(response => response?.data);
};
